<template>
    <div>
        <Topheader></Topheader>
        <div class="top-bodys">
            <div class="topd-left">{{info.signboard.title}}</div>
            <el-image class="topd-img" :src="info.signboard.img_url"></el-image>
        </div>

        <div class="w1100">

            <div class="price-body">
                <div class="price-left">
                    <div>
                        <span class="price-t">￥{{info.signboard.price}}</span>
                        <span class="price-u">{{info.signboard.unit}}</span>
                    </div>
                    <div class="price-s">{{info.signboard.publish_name}}</div>
                    <div class="price-s">{{info.signboard.address}}</div>
                    <div class="price-s">{{info.signboard.city_name}} ·{{info.signboard.province_name}}</div>
                </div>
                <div class="price-right">
                    <div>
                        <div class="username">{{info.user_name}}</div>
                        <div class="c-time">{{info.create_time}}</div>
                    </div>
                    <div>
                        <el-image class="user-head" :src="info.head_url"></el-image>
                    </div>
                </div>
            </div>


            <div class="ld-body">
                <div class="ld-tag-body">
                    <div class="ld-tag" v-for="vo in info.signboard.imgList1">{{vo.title}}</div>
                    <div class="ck-ld-body" v-if="info.signboard.imgList1.length > 1" @click="$router.push('/ldzgInfo?id='+id)">查看亮点展柜</div>
                </div>

                <div class="ld-img-body">
                    <div v-if="info.signboard.imgList1[0]">
                        <el-image class="ld-img1" fit="cover" :src="info.signboard.imgList1[0].img.url"></el-image>
                    </div>
                    <div v-if="info.signboard.imgList1[1]">
                        <el-image class="ld-img1" fit="cover" :src="info.signboard.imgList1[1].img.url"></el-image>
                    </div>

                    <div>
                        <el-image class="ld-img2"  v-if="info.signboard.imgList1[2]" fit="cover" :src="info.signboard.imgList1[2].img.url"></el-image>
                        <el-image class="ld-img2"  v-if="info.signboard.imgList1[3]" fit="cover" :src="info.signboard.imgList1[3].img.url"></el-image>
                    </div>
                    <div v-if="info.signboard.imgList1[4]">
                        <el-image class="ld-img1" fit="cover" :src="info.signboard.imgList1[4].img.url"></el-image>
                    </div>
                    <div v-if="info.signboard.imgList1[5]">
                        <el-image class="ld-img1" fit="cover" :src="info.signboard.imgList1[5].img.url"></el-image>
                    </div>

                </div>

                <div class="zp-spk">
                    招牌介绍
                </div>
                <div class="zp-spk-t">{{info.signboard.spk}}</div>

                <div class="imgs-body">
                    <el-image class="imgs-s" fit="cover" :src="vo" v-for="vo in info.signboard.imgList2"></el-image>
                </div>

                <div class="show-btn" v-if="info.signboard.imgList2.length > 1" @click="$router.push('/zpImgsInfo?id='+id)">
                    查看全部图集
                </div>

                <div class="zp-spk">
                    玩家规则
                </div>

                <div class="zp-content" v-html="info.signboard.content"></div>

                <div class="interFlow-body">
                    <img v-if="!is_focus && info.is_highlight" class="hi-icon"  @click="onHighlight()"  src="../../static/icon/highlighton.png" alt="">
                    <img v-if="!is_focus && !info.is_highlight" class="hi-icon"  @click="onHighlight()"  src="../../static/icon/highlight.png" alt="">
                    <input type="text" @focus="focusInput()" @blur="hideInput()" v-model="interflowContent" placeholder="Interflow…">
                    <div
                            class="button"
                            :class="interflowContent ? 'active' : ''"
                            v-show="is_focus == true"
                            @click="subInterflow()"
                    >Post</div>
                </div>

                <div class="in-num-body">
                    <span class="high-num">{{info.highlight_num}}次Highlight</span>
                    <span class="level-num">全部{{info.leave_num}}条发言</span>
                    <span class="yuex-num">{{info.show_num}}次悦享</span>
                </div>


                <div class="level-body">
                    <div class="level-list" v-for="(vo,key) in list" :key="key">
                        <div class="level-head">
                            <img class="user-head-img" :src="vo.head_url" alt="">
                            <div class="user-name">{{vo.user_name}} · </div>
                            <div class="level-time">{{vo.create_time}}</div>
                        </div>
                        <div class="level-content">{{vo.content}}</div>

                        <div class="level-c-body">
                            <div class="level-c-list" v-for="(v,k) in vo.children" :key="k">
                                <div class="level-head">
                                    <img class="userc-head-img" :src="v.head_url" alt="">
                                    <div class="user-name">{{v.user_name}} · </div>
                                    <div class="level-time">{{v.create_time}}</div>
                                </div>
                                <div class="level-c-content">{{v.content}}</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


        </div>

    </div>
</template>

<script>
    import Topheader from "../components/header"; //上传图片
    export default {
        components: {
            Topheader
        },
        name: "zpInfo",
        data() {
            return {
                is_focus:'',
                interflowContent:'',
                id: '',
                info:{
                    signboard:{
                        imgList1:[],
                        imgList2:[],
                    }
                },
                list:[]
            };
        },
        created() {
            document
                .querySelector("body")
                .setAttribute("style", "background-color:#fff");
            this.id=this.$route.query.id;
            this.getInfo();
        },
        //方法定义
        methods: {
            getInfo(){
                let _this=this;
                _this.common.request('api/dynamic/info',{id:_this.id},function (res) {
                    if(res.status == 200){
                        _this.info=res.data.info;
                        _this.list=res.data.list;
                    }
                })
            },
            //点击高光
            onHighlight() {
                let _this = this;
                let id = _this.id;
                _this.common.request(
                    "api/dynamic/highlight",
                    { id: id },
                    function(res) {
                        if (res.status == 200) {
                            _this.common.vMessage(res.message);
                            _this.info.highlight_num = res.data.highlight_num; //
                            _this.info.is_highlight = !_this.info.is_highlight; //
                        }
                    },
                    "post"
                );
            },
            //留言
            subInterflow() {
                let _this = this;
                console.log(213210);
                if (!_this.interflowContent) {
                    this.hideInput();
                    return;
                }
                let data = {
                    dynamic_id: _this.id,
                    content: _this.interflowContent,
                    page_num: 3
                };
                _this.common.request(
                    "api/dynamicLeave/interflow",
                    data,
                    function(res) {
                        if (res.status == 200) {
                            _this.common.vMessage(res.message);
                            _this.interflowContent = null;
                            _this.getInfo();
                            _this.hideInput();
                        }
                    },
                    "post"
                );
            },
            focusInput(){
                this.is_focus=true;
            },
            hideInput(){
                if(!this.interflowContent){
                    this.is_focus=false;
                }
            }
        }
    }
</script>

<style scoped lang='less' rel="stylesheet/less">

.top-bodys{
    width: 1100px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
}
.topd-left{
    width:314px;
    font-size:36px;
    font-family:PingFang SC;
    font-weight:800;
    color:rgba(72,72,72,1);
    margin-top: 100px;
}
    .topd-img{
        width:880px;
        height:568px;
    }

    .price-body{
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
    }
    .price-t{
        font-size:36px;
        font-family:PingFang SC;
        font-weight:800;
        color:rgba(72,72,72,1);
    }
    .price-u{
        font-size:14px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(72,72,72,1);
        margin-left: 8px;
    }
    .price-s{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(72,72,72,1);
    }
    .price-right{
        display: flex;
        justify-content: flex-end;
    }
    .username{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:bold;
        color:rgba(72,72,72,1);
        text-align: right;
    }
    .c-time{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(142,152,159,1);
        text-align: right;
    }
    .user-head{
        width:84px;
        height:84px;
        border-radius:50%;
        margin-left: 10px;
    }

    .ld-tag-body{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 800px;
    }
    .ld-tag{
        font-size:20px;
        font-family:PingFang SC;
        font-weight:bold;
        color:rgba(72,72,72,1);
        margin-right: 10px;
    }

    .ck-ld-body{
        width:120px;
        height:34px;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 4px 0px rgba(114,114,114,1);
        border-radius:10px;
        text-align: center;
        line-height: 34px;
        font-size:16px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(29,134,232,1);
        cursor: pointer;
        margin-left: 10px;
    }
.ck-ld-body:hover{
    color:rgba(29,134,232,0.8);
}
    .ld-img-body{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 10px;
    }
.ld-img-body>div{
    margin-right: 10px;
}
    .ld-img1{
        width:215px;
        height:305px;
    }
    .ld-img2{
        width:215px;
        height:150px;
    }
    .ld-img-body>div{
        width: 215px;
    }
    .zp-spk{
        font-size:26px;
        font-family:PingFang SC;
        font-weight:bold;
        color:rgba(161,169,174,1);
        margin-top: 10px;
    }
    .zp-spk-t{
        font-size:18px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(72,72,72,1);
        line-height:44px;
    }
    .imgs-body{
        display: flex;
        flex-wrap: wrap;
    }
    .imgs-s{
        width:352px;
        height:352px;
        margin-top: 10px;
        margin-right: 10px;
    }
    .show-btn{
        font-size:16px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:rgba(0,132,137,1);
        line-height:54px;
        cursor: pointer;
    }

.show-btn:hover{
    color:rgba(0,132,137,0.8);
}
    .zp-content{
        padding: 10px 0;
    }

.interFlow-body{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 50px;
    border-top: 1px solid #EDEDED;
    border-bottom: 1px solid #EDEDED;
    margin-top: 20px;

}
.hi-icon{
    width:22px;
    height:22px;
    margin-right: 20px;
    cursor: pointer;
}
input{
    background: none;
}
.button {
    color: #15a3f5;
    font-size: 14px;
    width: 62px;
    height: 26px;
    line-height: 26px;
    background: #e8e8e8;
    border-radius: 13px;
    text-align: center;
    cursor: pointer;
}
.button.active {
    color: #fff;
    background: #15a3f5;
}
.button:hover {
    color: #fff;
    background: #15a3f5;
}
.in-num-body{
    margin-top: 20px;
}
.high-num{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(20,20,20,1);
    line-height:24px;
}
.level-num{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(99,99,99,1);
    line-height:24px;
    margin-left: 10px;
}
.yuex-num{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(99,99,99,1);
    line-height:24px;
    margin-left: 10px;
}
.level-list{
    padding: 20px 0;
    border-bottom: 1px solid #EDEDED;
}

.level-head{
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.user-head-img{
    width:44px;
    height:44px;
    border-radius:50%;
}

.user-name{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(72,72,72,1);
    margin-left: 20px;
}

.level-time{
    font-size:14px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(72,72,72,1);
    margin-left: 20px;
}
.level-content{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(72,72,72,1);
    margin-top: 20px;
    margin-left: 10px;
}
.level-c-body{
    margin-left: 10px;
    margin-top: 20px;
}
.level-c-list{
    margin-top: 20px;
}
.userc-head-img{
    width:32px;
    height:32px;
    border-radius:50%;
}
.level-c-content{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(72,72,72,1);
    margin-left: 55px;
}


</style>


// WEBPACK FOOTER //
// src/view/zpInfo.vue